import React from "react";
import { services } from "../mock/services";

const Home = () => {
  return (
    <>
      <div id="content" className="site-content">
        <div className="container ct-lv1">
          <div className="row">
            <div
              id="primary"
              className="content-area content-page col-xs-12 col-sm-12 col-md-12 col-lg-12"
            >
              <main id="main" className="site-main" role="main">
                <div
                  id="post-526"
                  className="post-526 page type-page status-publish hentry"
                >
                  <div className="entry-content">
                    <div className="wpb-content-wrapper">
                      <div className="vc_row wpb_row vc_row-fluid vc_custom_1451621340030">
                        <div className="wpb_column vc_column_container vc_col-sm-12">
                          <div className="vc_column-inner">
                            <div className="wpb_wrapper">
                              <div className="wpb_revslider_element wpb_content_element">
                                {/* START Home REVOLUTION SLIDER 6.5.21 */}
                                <p className="rs-p-wp-fix" />
                                <rs-module-wrap
                                  id="rev_slider_3_1_wrapper"
                                  data-source="gallery"
                                  style={{
                                    visibility: "hidden",
                                    background: "transparent",
                                    padding: 0,
                                    margin: "0px auto",
                                    marginTop: 0,
                                    marginBottom: 0,
                                  }}
                                >
                                  <rs-module
                                    id="rev_slider_3_1"
                                    style={{}}
                                    data-version="6.5.21"
                                  >
                                    <rs-slides>
                                      <rs-slide
                                        style={{ position: "absolute" }}
                                        data-key="rs-5"
                                        data-title="Slide"
                                        data-anim="ms:600;"
                                        data-in="o:0;"
                                        data-out="a:false;"
                                      >
                                        <img
                                          decoding="async"
                                          src="wp-content/plugins/revslider/public/assets/assets/dummy.png"
                                          alt=""
                                          title="Home"
                                          className="rev-slidebg tp-rs-img rs-lazyload"
                                          data-lazyload="https://images.unsplash.com/photo-1479142506502-19b3a3b7ff33?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                                          data-no-retina=""
                                        />{" "}
                                        {/*
                                         */}
                                        <rs-layer
                                          id="slider-3-slide-5-layer-1"
                                          className="con_medium_text"
                                          data-type="text"
                                          data-color="rgba(255,255,255,1)"
                                          data-rsp_ch="on"
                                          data-xy="x:410px;y:260px;"
                                          data-text="s:48;l:48;fw:300;"
                                          data-frame_0="tp:600;"
                                          data-frame_1="tp:600;e:power2.inOut;st:500;"
                                          data-frame_999="o:0;tp:600;e:nothing;st:w;"
                                          style={{
                                            zIndex: 5,
                                            fontFamily: '"Raleway"',
                                            textAlign: "left",
                                            position: "absolute",
                                            margin: 0,
                                            whiteSpace: "nowrap",
                                            type: "text",
                                          }}
                                        >
                                          TRUSTED{" "}
                                        </rs-layer>
                                        {/*
                                         */}
                                        <rs-layer
                                          id="slider-3-slide-5-layer-2"
                                          className="con_large_text"
                                          data-type="text"
                                          data-color="rgba(255,255,255,1)"
                                          data-rsp_ch="on"
                                          data-xy="x:410px;y:315px;"
                                          data-text="s:48;l:48;fw:800;"
                                          data-frame_0="tp:600;"
                                          data-frame_1="tp:600;e:power2.inOut;st:500;"
                                          data-frame_999="o:0;tp:600;e:nothing;st:w;"
                                          style={{
                                            zIndex: 6,
                                            fontFamily: '"Raleway"',
                                            textAlign: "left",
                                            whiteSpace: "nowrap",
                                            type: "text",
                                          }}
                                        >
                                          PROFESSIONAL ADVISORS{" "}
                                        </rs-layer>
                                        {/*
                                         */}
                                        <a href="/Contact">
                                          <rs-layer
                                            id="slider-3-slide-5-layer-3"
                                            className="Sports-Button-Red rev-btn"
                                            data-type="button"
                                            data-color="rgba(255,255,255,1)"
                                            data-xy="x:410px;y:393px;"
                                            data-text="s:14;l:14;fw:700;"
                                            data-rsp_bd="off"
                                            data-padding="t:17;r:30;b:17;l:30;"
                                            data-border="bos:solid;bow:2px,2px,2px,2px;"
                                            data-frame_0="tp:600;"
                                            data-frame_1="tp:600;e:power2.inOut;st:500;"
                                            data-frame_999="o:0;tp:600;e:nothing;st:w;"
                                            data-frame_hover="bgc:#000;boc:#000;bor:0px,0px,0px,0px;bos:solid;bow:2,2,2,2;oX:50;oY:50;sp:500;e:none;"
                                            style={{
                                              zIndex: 7,
                                              backgroundColor:
                                                "rgba(254,87,34,1)",
                                              fontFamily: '"Karla"',
                                              outline: "none",
                                              boxShadow: "none",
                                              boxSizing: "border-box",
                                              MozBoxSizing: "border-box",
                                              WebkitBoxSizing: "border-box",
                                              letterSpacing: 2,
                                              textAlign: "left",
                                              type: "button",
                                            }}
                                          >
                                            CONTACT US &gt;{" "}
                                          </rs-layer>
                                        </a>
                                        {/*
                                         */}
                                      </rs-slide>
                                    </rs-slides>
                                  </rs-module>
                                </rs-module-wrap>
                                {/* END REVOLUTION SLIDER */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        data-vc-full-width="true"
                        data-vc-full-width-init="false"
                        className="vc_row wpb_row vc_row-fluid vc_custom_1451621476587 vc_row-has-fill"
                      >
                        <div className="background-box wpb_column vc_column_container vc_col-sm-12 vc_col-has-fill">
                          <div className="vc_column-inner vc_custom_1451624045846">
                            <div className="wpb_wrapper">
                              <div
                                className="st-custom-heading-wraper st-custom-heading-layout1 text-default "
                                style={{ marginBottom: 37 }}
                              >
                                <h2
                                  className="st-heading-title"
                                  style={{ color: "none" }}
                                >
                                  {" "}
                                  <span className="heading-text">
                                    {" "}
                                    About Us
                                  </span>
                                </h2>
                                <hr
                                  className="heading-line"
                                  style={{ background: "none" }}
                                />
                              </div>
                              <div className="vc_row wpb_row vc_inner vc_row-fluid vc_custom_1451347952570">
                                <p>
                                  At “LEGALNEST PROFESSIONAL ADVSIORY”, we are
                                  committed to empowering businesses with expert
                                  legal and compliance solutions tailored for
                                  today’s dynamic regulatory landscape. With a
                                  team of experienced attorneys, compliance
                                  specialists, and industry professionals, we
                                  partner with our clients to navigate complex
                                  legal challenges and ensure their operations
                                  remain compliant and future-ready.
                                </p>
                                <p>
                                  Our firm offers comprehensive services in
                                  corporate law, regulatory compliance, risk
                                  management, and dispute resolution, providing
                                  practical, proactive, and innovative
                                  solutions.
                                </p>
                                <p>
                                  We believe in fostering strong client
                                  relationships built on trust, transparency,
                                  and collaboration.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="vc_row-full-width vc_clearfix" />

                      <div
                        id="primary"
                        className="content-area content-page col-xs-12 col-sm-12 col-md-12 col-lg-12"
                      >
                        <main id="main" className="site-main" role="main">
                          <div
                            id="post-324"
                            className="post-324 page type-page status-publish hentry"
                          >
                            <div className="entry-content">
                              <div className="wpb-content-wrapper">
                                <div className="vc_row wpb_row vc_row-fluid vc_custom_1448960423081">
                                  <div className="wpb_column vc_column_container vc_col-sm-12">
                                    <div className="vc_column-inner">
                                      <div className="wpb_wrapper">
                                        <div
                                          className="st-custom-heading-wraper st-custom-heading-layout1 text-default"
                                          style={{ marginBottom: "" }}
                                        >
                                          <h2
                                            className="st-heading-title"
                                            style={{ color: "" }}
                                          >
                                            <span className="heading-text">
                                              Key Operational Domain of the Firm
                                            </span>
                                          </h2>
                                          <hr
                                            className="heading-line"
                                            style={{ background: "" }}
                                          />
                                        </div>
                                        <div className="vc_row wpb_row vc_inner vc_row-fluid">
                                          <div className="wpb_column vc_column_container vc_col-sm-12">
                                            <div className="vc_column-inner">
                                              <div className="wpb_wrapper">
                                                <div className="st-client-wraper st-client-layout2">
                                                  <div className="st-client-inner clearfix">
                                                    <i className="fa fa-quote-left tertiary-border secondary-color" />
                                                    <div className="st-client-desctiption">
                                                      <ul
                                                        className="ul"
                                                        style={{
                                                          display: "flex",
                                                          flexWrap: "wrap",
                                                        }}
                                                      >
                                                        {services.map(
                                                          (service, index) => (
                                                            <li
                                                              key={index}
                                                              style={{
                                                                width: "50%",
                                                              }}
                                                            >
                                                              {service.name}
                                                            </li>
                                                          )
                                                        )}
                                                      </ul>
                                                    </div>
                                                  </div>
                                                </div>
                                                <br />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="vc_row-full-width vc_clearfix" />
                              </div>
                            </div>
                            {/* .entry-content */}
                            <div className="page-edit" />
                            {/* .entry-footer */}
                          </div>
                          {/* #post-## */}
                        </main>
                        {/* #main */}
                      </div>

                      <div className="vc_row-full-width vc_clearfix" />
                      <br />
                      <br />
                      <br />
                      <br />
                      {/* <div className="vc_row wpb_row vc_row-fluid vc_custom_1451637598418">
                        <div className="wpb_column vc_column_container vc_col-sm-12">
                          <div className="vc_column-inner">
                            <div className="wpb_wrapper">
                              <div
                                className="st-custom-heading-wraper st-custom-heading-layout2 text-center "
                                style={{ marginBottom: 40 }}
                              >
                                <h2
                                  className="st-heading-title"
                                  style={{ color: "none" }}
                                >
                                  {" "}
                                  <span> Our Clients</span>
                                </h2>
                                <hr
                                  className="heading-line"
                                  style={{ background: "none" }}
                                />
                              </div>
                              <div className="st-carousel-all-wrap st-carousel-all-layout1 ">
                                <div
                                  className="st-carousel"
                                  data-margin={30}
                                  data-loop="false"
                                  data-nav="false"
                                  data-dots="true"
                                  data-autoplay="true"
                                  data-xsmall-items={3}
                                  data-small-items={4}
                                  data-medium-items={5}
                                  data-large-items={6}
                                >
                                  <div className="vc_row wpb_row vc_inner vc_row-fluid">
                                    <div className="wpb_column vc_column_container vc_col-sm-12">
                                      <div className="vc_column-inner">
                                        <div className="wpb_wrapper">
                                          <div className="st-partner-wraper st-partner-layout1 ">
                                            <div className="st-partner-inner clearfix">
                                              <div className="st-partner-image">
                                                {" "}
                                                <a href="/#">
                                                  <img
                                                    decoding="async"
                                                    src="wp-content/uploads/2015/11/partner1.png"
                                                    alt=""
                                                  />
                                                </a>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="vc_row wpb_row vc_inner vc_row-fluid">
                                    <div className="wpb_column vc_column_container vc_col-sm-12">
                                      <div className="vc_column-inner">
                                        <div className="wpb_wrapper">
                                          <div className="st-partner-wraper st-partner-layout1 ">
                                            <div className="st-partner-inner clearfix">
                                              <div className="st-partner-image">
                                                {" "}
                                                <a href="/#">
                                                  <img
                                                    decoding="async"
                                                    src="wp-content/uploads/2015/11/partner2.png"
                                                    alt=""
                                                  />
                                                </a>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="vc_row wpb_row vc_inner vc_row-fluid">
                                    <div className="wpb_column vc_column_container vc_col-sm-12">
                                      <div className="vc_column-inner">
                                        <div className="wpb_wrapper">
                                          <div className="st-partner-wraper st-partner-layout1 ">
                                            <div className="st-partner-inner clearfix">
                                              <div className="st-partner-image">
                                                {" "}
                                                <a href="/#">
                                                  <img
                                                    decoding="async"
                                                    src="wp-content/uploads/2015/11/partner3.png"
                                                    alt=""
                                                  />
                                                </a>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="vc_row wpb_row vc_inner vc_row-fluid">
                                    <div className="wpb_column vc_column_container vc_col-sm-12">
                                      <div className="vc_column-inner">
                                        <div className="wpb_wrapper">
                                          <div className="st-partner-wraper st-partner-layout1 ">
                                            <div className="st-partner-inner clearfix">
                                              <div className="st-partner-image">
                                                {" "}
                                                <a href="/#">
                                                  <img
                                                    decoding="async"
                                                    src="wp-content/uploads/2015/11/partner4.png"
                                                    alt=""
                                                  />
                                                </a>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="vc_row wpb_row vc_inner vc_row-fluid">
                                    <div className="wpb_column vc_column_container vc_col-sm-12">
                                      <div className="vc_column-inner">
                                        <div className="wpb_wrapper">
                                          <div className="st-partner-wraper st-partner-layout1 ">
                                            <div className="st-partner-inner clearfix">
                                              <div className="st-partner-image">
                                                {" "}
                                                <a href="/#">
                                                  <img
                                                    decoding="async"
                                                    src="wp-content/uploads/2015/11/partner5.png"
                                                    alt=""
                                                  />
                                                </a>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="vc_row wpb_row vc_inner vc_row-fluid">
                                    <div className="wpb_column vc_column_container vc_col-sm-12">
                                      <div className="vc_column-inner">
                                        <div className="wpb_wrapper">
                                          <div className="st-partner-wraper st-partner-layout1 ">
                                            <div className="st-partner-inner clearfix">
                                              <div className="st-partner-image">
                                                {" "}
                                                <a href="/#">
                                                  <img
                                                    decoding="async"
                                                    src="wp-content/uploads/2015/11/partner6.png"
                                                    alt=""
                                                  />
                                                </a>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="vc_row wpb_row vc_inner vc_row-fluid">
                                    <div className="wpb_column vc_column_container vc_col-sm-12">
                                      <div className="vc_column-inner">
                                        <div className="wpb_wrapper">
                                          <div className="st-partner-wraper st-partner-layout1 ">
                                            <div className="st-partner-inner clearfix">
                                              <div className="st-partner-image">
                                                {" "}
                                                <a href="/#">
                                                  <img
                                                    decoding="async"
                                                    src="wp-content/uploads/2015/11/partner7.png"
                                                    alt=""
                                                  />
                                                </a>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="vc_row wpb_row vc_inner vc_row-fluid">
                                    <div className="wpb_column vc_column_container vc_col-sm-12">
                                      <div className="vc_column-inner">
                                        <div className="wpb_wrapper">
                                          <div className="st-partner-wraper st-partner-layout1 ">
                                            <div className="st-partner-inner clearfix">
                                              <div className="st-partner-image">
                                                {" "}
                                                <a href="/#">
                                                  <img
                                                    decoding="async"
                                                    src="wp-content/uploads/2015/11/partner8.png"
                                                    alt=""
                                                  />
                                                </a>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div> */}
                      <div className="vc_row-full-width vc_clearfix" />
                    </div>
                  </div>
                  {/* .entry-content */}
                  <div className="page-edit" />
                  {/* .entry-footer */}
                </div>
                {/* #post-## */}
              </main>
              {/* #main */}
            </div>
            {/* #primary */}
          </div>
          {/* #row */}
        </div>
        {/* #container */}
      </div>

      <div id="content" className="site-content">
        <div
          className="page-title-wrap text-left parallax"
          style={{ padding: "", backgroundAttachment: "fixed" }}
        >
          <div className="container">
            <h1 className="page-title display_none" style={{ color: "" }}>
              <span>Testimonial</span>
            </h1>
          </div>
        </div>
        {/* #container */}
      </div>
    </>
  );
};

export default Home;
